import { StyledFooterRow } from './index.styled'
import { Button } from 'antd'
import { EEmitEventModal } from 'enums'
import { useModal } from 'hooks'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { commonSelector } from 'store/commonSlice'

interface IProps {
  okLabel?: string
  sendLabel?: string
  cancelLabel?: string
  disabled?: boolean
  okAndContinue?: string
  loading?: boolean
  className?: string
  children?: ReactNode
  onSubmit?: () => void
  onCancel?: () => void
  onOkAndContinue?: () => void
  emitEvent?: (event: EEmitEventModal) => void
  closeModal?: (success: boolean) => void
  onSendAction?: (data?: string) => void
  enableSendAction?: boolean
}
const FooterModal = (props: IProps) => {
  const {
    okLabel = 'confirm',
    cancelLabel = 'go-back',
    okAndContinue = '',
    sendLabel,
    disabled,
    loading,
    closeModal,
    className,
    onSubmit,
    onOkAndContinue,
    onSendAction,
    children
  } = props
  const { t } = useTranslation()
  const { loading: modalLoading, enableSend } =
    useSelector(commonSelector).modal
  const { close, modalSetting, emitEvent } = useModal()
  const handleClose = () => {
    if (modalSetting.emitEvent) {
      emitEvent(modalSetting.emitEvent)
      return
    }
    close(false)
  }
  const handleAcceptAndContinue = () => {
    if (onOkAndContinue) {
      onOkAndContinue()
      return
    }
    if (modalSetting.emitEvent) {
      emitEvent(modalSetting.emitEvent)
      return
    }
  }
  const handleAccept = () => {
    if (onSubmit) {
      onSubmit()
      return
    }
    if (modalSetting.emitEvent) {
      emitEvent(modalSetting.emitEvent)
      return
    }
    close(true)
  }
  const onSend = () => {
    if (onSendAction) {
      onSendAction('onSend')
      return
    }
    close(false)
  }

  if (closeModal) {
    closeModal(true)
  }
  return (
    <StyledFooterRow className={`${className} footer-modal`}>
      <Button disabled={loading || modalLoading} onClick={handleClose}>
        {t(cancelLabel)}
      </Button>
      {okAndContinue && (
        <Button
          loading={loading || modalLoading}
          type="primary"
          onClick={handleAcceptAndContinue}
          disabled={disabled || modalLoading}>
          {t(okAndContinue)}
        </Button>
      )}
      {sendLabel && (
        <Button
          loading={loading || modalLoading}
          type="primary"
          disabled={enableSend === 'disable'}
          onClick={onSend}>
          {t(sendLabel)}
        </Button>
      )}
      <Button
        loading={loading || modalLoading}
        type="primary"
        onClick={handleAccept}
        disabled={disabled || modalLoading}>
        {t(okLabel)}
      </Button>
      {children}
    </StyledFooterRow>
  )
}

export default FooterModal
